import { render, staticRenderFns } from "./gc-decimal.vue?vue&type=template&id=ed0b3080&scoped=true"
import script from "./gc-decimal.vue?vue&type=script&lang=js"
export * from "./gc-decimal.vue?vue&type=script&lang=js"
import style0 from "./gc-decimal.vue?vue&type=style&index=0&id=ed0b3080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0b3080",
  null
  
)

export default component.exports